let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bocK9")).then(() => parcelRequire('jXZsN'));